<template>
  <PlaceholderPantalla
    titulo="Reportes Financieros"
    subtitulo="Centro de reportes y análisis financiero"
    descripcion="Genera reportes financieros completos y personalizados. Desde estados de resultados hasta análisis de rentabilidad, esta sección te permite crear reportes con diferentes períodos, formatos y niveles de detalle para tomar decisiones estratégicas basadas en datos."
    :funcionalidades="funcionalidades"
    :datos-manejados="datosManejados"
    :mostrar-mockup="true"
  />
</template>

<script setup>
import PlaceholderPantalla from '../PlaceholderPantalla.vue'

const funcionalidades = [
  'Estado de Resultados (Ingresos - Gastos = Utilidad)',
  'Reporte de Flujo de Efectivo detallado',
  'Balance General (Activos, Pasivos, Capital)',
  'Análisis de Cuentas por Cobrar (antigüedad, clientes morosos)',
  'Análisis de Cuentas por Pagar (próximos vencimientos, proveedores)',
  'Reporte de Gastos por Categoría con gráficas',
  'Reporte de Ingresos por Categoría y fuente',
  'Análisis de Rentabilidad por producto/servicio',
  'Comparativo de períodos (mes vs mes, año vs año)',
  'Reportes de movimientos bancarios por cuenta',
  'Análisis de presupuesto vs real',
  'Reportes fiscales y deducibles',
  'Personalización de reportes (columnas, filtros, agrupaciones)',
  'Exportar en múltiples formatos: PDF, Excel, CSV',
  'Programar envío automático de reportes por email',
  'Dashboard ejecutivo con KPIs principales'
]

const datosManejados = [
  'Período de análisis (fecha inicio y fin)',
  'Tipo de reporte seleccionado',
  'Filtros aplicados (cuentas, categorías, clientes)',
  'Nivel de detalle (resumido, detallado)',
  'Agrupaciones (por día, semana, mes, categoría)',
  'Totales y subtotales',
  'Porcentajes y variaciones',
  'Gráficas y visualizaciones',
  'Indicadores financieros (ROI, margen, etc.)',
  'Comparativos históricos',
  'Formato de exportación',
  'Programación de reportes recurrentes'
]
</script>
